import { useMutation } from '@tanstack/react-query';
import { saveLibraryManagedProductGroupsOrder } from './apiSaveLibraryManagedProductGroupsOrder';
import { invalidateLibraryManagedProductGroupFeaturedPages } from './useLibraryManagedProductGroupsFeaturePages';
import { useDispatch } from 'react-redux';
import { globalErrorResponse } from '../../../../store/notifications/actions';
import { useTranslation } from 'react-i18next';

export const useSaveLibraryManagedProductGroupsOrder = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    return useMutation(saveLibraryManagedProductGroupsOrder, {
        onSuccess: () => {
            invalidateLibraryManagedProductGroupFeaturedPages().then();
        },
        onError: () => dispatch(globalErrorResponse(t('marketing.productGroups.warnings.saveGroupOrderError')))
    });
};
